import { ComponentType } from 'react'

// Pages - LP
import LandingPage from '../pages/landing/landing_page'
import PolicyUserPage from '../pages/policy/policy_user_page'
import PolicyLawPage from '../pages/policy/policy_law_page'
import PolicyPrivacyPage from '../pages/policy/policy_privacy_page'

// Pages - 認証
import LoginPage from '../pages/auth/login_page'
import TokenExchangePage from '../pages/auth/token_exchange_page'
import PasswordResetRequestPage from '../pages/password/password_reset_request_page'
import PasswordResetSendPage from '../pages/password/password_reset_send_page'
import PasswordResetInputPage from '../pages/password/password_reset_input_page'
import PasswordResetCompletePage from '../pages/password/password_reset_complete_page'

// Pages - 登録
import RegisterPage from '../pages/register/register_page'
import RegisterCompletePage from '../pages/register/register_complete_page'
import RegisterMailSendPage from '../pages/register/register_mail_send_page'
import RegisterMailSendCompletePage from '../pages/register/register_mail_send_complete_page'

// Pages - 認証必須
import TopPage from '../pages/top/top_page'
import FavoriteEnterprisesPage from '../pages/favorite_enterprises/favorite_enterprises_page'
import MatchingEnterprisesPage from '../pages/matching_enterprises/matching_enterprises_page'
import MyIdeaPage from '../pages/myidea/myidea_page'
import EnterprisesSearchPage from '../pages/enterprises_search/enterprises_search'
import EnterprisesDetailPage from '../pages/enterprises_detail/enterprises_detail_page'
import EnterprisesDetailEditPage from '../pages/enterprises_detail/edit/enterprises_detail_edit_page'
import BusinessDetailPage from '../pages/business_detail/business_detail_page'
import AsiatoPage from '../pages/asiato/asiato_page'
import RecruitmentPage from '../pages/recruitment/recruitment_page'
import RecruitmentManagePage from '../pages/recruitment/recruitment_manage_page'
import RecruitmentCreatePage from '../pages/recruitment/recruitment_create_page'
import RecruitmentEditPage from '../pages/recruitment/recruitment_edit_page'
import RecruitmentDetailPage from '../pages/recruitment/recruitment_detail_page'
import ChatPage from '../pages/chat/chat_page'
import ContactPage from '../pages/contact/contact_page'
import ContactConfirmPage from '../pages/contact/contact_confirm_page'
import ContactCompletePage from '../pages/contact/contact_complete_page'
import FaqPage from '../pages/faq/faq_page'

/**
 * ルートタイプの定義
 * - guest: ゲスト専用（未認証時のみアクセス可能）
 * - authenticated: 認証必須（ログイン時のみアクセス可能）
 * - public: 誰でもアクセス可能（将来的な拡張用）
 */
export type RouteType = 'guest' | 'authenticated' | 'public'

export interface RouteConfig {
  path: string
  element: ComponentType
  type: RouteType
}

export const routes: RouteConfig[] = [
  // 公開ルート
  { path: '/', element: LandingPage, type: 'public' },
  {
    path: '/policy/user',
    element: PolicyUserPage,
    type: 'public',
  },
  {
    path: '/policy/law',
    element: PolicyLawPage,
    type: 'public',
  },
  {
    path: '/policy/privacy',
    element: PolicyPrivacyPage,
    type: 'public',
  },
  {
    path: '/contact',
    element: ContactPage,
    type: 'public',
  },
  {
    path: '/contact/confirm',
    element: ContactConfirmPage,
    type: 'public',
  },
  {
    path: '/contact/complete',
    element: ContactCompletePage,
    type: 'public',
  },
  {
    path: '/faq',
    element: FaqPage,
    type: 'public',
  },

  // ゲスト専用ルート（未認証時のみアクセス可能）

  { path: '/login', element: LoginPage, type: 'guest' },
  { path: '/auth/token', element: TokenExchangePage, type: 'public' },
  {
    path: '/password/reset/request',
    element: PasswordResetRequestPage,
    type: 'guest',
  },
  {
    path: '/password/reset/send',
    element: PasswordResetSendPage,
    type: 'guest',
  },
  {
    path: '/password/reset/input/:token',
    element: PasswordResetInputPage,
    type: 'guest',
  },
  {
    path: '/password/reset/complete',
    element: PasswordResetCompletePage,
    type: 'guest',
  },
  { path: '/register/:token', element: RegisterPage, type: 'guest' },
  { path: '/register/complete', element: RegisterCompletePage, type: 'guest' },
  { path: '/register/mail/send', element: RegisterMailSendPage, type: 'guest' },
  {
    path: '/register/mail/send/complete',
    element: RegisterMailSendCompletePage,
    type: 'guest',
  },

  // 認証必須ルート（ログイン時のみアクセス可能）
  { path: '/dashboard', element: TopPage, type: 'authenticated' },
  {
    path: '/enterprises/favorite',
    element: FavoriteEnterprisesPage,
    type: 'authenticated',
  },
  {
    path: '/enterprises/matching',
    element: MatchingEnterprisesPage,
    type: 'authenticated',
  },
  {
    path: '/myidea',
    element: MyIdeaPage,
    type: 'authenticated',
  },
  {
    path: '/enterprises/search',
    element: EnterprisesSearchPage,
    type: 'authenticated',
  },
  {
    path: '/enterprises/detail/:id',
    element: EnterprisesDetailPage,
    type: 'authenticated',
  },
  {
    path: '/enterprises/edit',
    element: EnterprisesDetailEditPage,
    type: 'authenticated',
  },
  {
    path: '/business/detail/:id',
    element: BusinessDetailPage,
    type: 'authenticated',
  },
  {
    path: '/asiato',
    element: AsiatoPage,
    type: 'authenticated',
  },
  //共創パートナー募集
  {
    path: '/recruitment',
    element: RecruitmentPage,
    type: 'authenticated',
  },
  {
    path: '/recruitment/manage',
    element: RecruitmentManagePage,
    type: 'authenticated',
  },
  {
    path: '/recruitment/create',
    element: RecruitmentCreatePage,
    type: 'authenticated',
  },
  {
    path: '/recruitment/:id/edit',
    element: RecruitmentEditPage,
    type: 'authenticated',
  },
  {
    path: '/recruitment/:id',
    element: RecruitmentDetailPage,
    type: 'authenticated',
  },
  {
    path: '/chat',
    element: ChatPage,
    type: 'authenticated',
  },
]
